import { render, staticRenderFns } from "./ReReassignExtCalls.vue?vue&type=template&id=fa4fea28&scoped=true"
import script from "./ReReassignExtCalls.vue?vue&type=script&lang=js"
export * from "./ReReassignExtCalls.vue?vue&type=script&lang=js"
import style0 from "./ReReassignExtCalls.vue?vue&type=style&index=0&id=fa4fea28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4fea28",
  null
  
)

export default component.exports